export default __webpack_public_path__ + "static/media/phone.59386642.svg";